import * as types from '../actions/actionTypes';

export default function flagsReducer(state: any = {}, action: any) {
    switch (action.type) {
        case types.FLAGS_SET:
            return { ...state, ...action.flags };
        default:
            return state;
    }
}